// 404 Page Not Found
export const emptyBG = require('./misc/404-img.png');

// Misc
export const logoLandscape = require('./misc/logo-landscape.png');
export const logoPortrait = require('./misc/logo-vertical.png');
export const appStoreIcon = require('./redirect/app_store.png');
export const playStoreIcon = require('./redirect/google_play.png');
export const allStarCarIcon = require('./misc/allStarCar.png');



// Public Tracking
export const dropoffIcon = require('./public-tracking/map_dropoff.png');
export const pickupIcon = require('./public-tracking/map_pickup.png');
export const taxiIcon = require('./public-tracking/taxi-white.png');

export const logoIcon = require('./svg/logo.svg');
export const luggageIcon = require('./svg/luggage.svg');
export const passengerIcon = require('./svg/passenger.svg');
export const rightIcon = require('./svg/right.svg');
export const timeIcon = require('./svg/time.svg');

export const luggageWhiteIcon = require('./svg/luggage-w.svg');
export const passengerWhiteIcon = require('./svg/passenger-w.svg');
export const timeWhiteIcon = require('./svg/time-w.svg');
export const defaultLogo = require('./svg/logo-hori-border.svg');
export const phoneIcon = require('./svg/phone.svg');
export const errorPlaceholder = require('./redirect/error.png');
export const inactivePlaceholder = require('./redirect/inactive.png');
export const cancelledbyPassengerPlaceholder = require('./redirect/cancelledbyPassenger.png');
export const cancelledbyDriverPlaceholder = require('./redirect/cancelledbyDriver.png');
export const noShowPlaceholder = require('./redirect/noShow.png');

export const upArrow = require('./svg/up-arrow.svg');
export const downArrow = require('./svg/down-arrow.svg');
export const fromDestination = require('./public-tracking/from_destination.png');

export const mainLogo = require('./home/mainLogo.png');
